import { FuelStationOutputWithStatus } from './fuel-station-output-with-status.model';


export class FuelStationSelectByIdOutput implements IFuelStationSelectByIdOutput {
    status!: number;
    message!: string;
    data!: FuelStationOutputWithStatus;

    constructor(data?: IFuelStationSelectByIdOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            this.data = _data["data"] ? FuelStationOutputWithStatus.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FuelStationSelectByIdOutput {
        data = typeof data === 'object' ? data : {};
        let result = new FuelStationSelectByIdOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IFuelStationSelectByIdOutput {
    status: number;
    message: string;
    data: FuelStationOutputWithStatus;
}

